const LinkedInPostViewMock = () => (
  <div style={{ border: "1px solid #ddd", padding: 15, marginTop: 15 }}>
    <strong>MetricMind</strong>
    <p>
      We’re excited to share how we analyze early digital signals 🚀
    </p>
    <small>👍 124 • 💬 18</small>
  </div>
);

export default LinkedInPostViewMock;
